export default __webpack_public_path__ + "static/media/9.818a3c0f.png";